import { Form, Switch } from 'antd';
import { FloatInput } from '../../../../../../../components/Fields/FloatInput';
import { FloatSelect } from '../../../../../../../components/Fields/FloatSelect';
import { isFieldIdInErrors } from '../../builderFormUtils';

export const ResponceValidation = ({
    findItem,
    fieldsError,
    updateSettingField,
    updateOptionSelectedInSetting,
    deselectAllOptions,
    updateNestedOptionSelected,
    deselectAllNestedOptions,
    updateNestedOptionField,
    updateRadioOptionSelectedInSetting
}: any) => {
    return (
        <div>
            {' '}
            {findItem()?.settings?.map((setting: any) => {
                if (setting.type === 'response_validation') {
                    const selectedValidationType = setting?.options?.find((option: any) => option.selected);
                    const selectedCondition = selectedValidationType?.options?.find((opt: any) => opt.selected!);

                    const selectedNumber =
                        selectedValidationType?.value === 'number' && selectedCondition && 'value' in selectedCondition
                            ? Boolean(selectedCondition.value)
                            : true;

                    const selectedPattern =
                        selectedValidationType?.value === 'text' && selectedCondition && 'pattern' in selectedCondition
                            ? Boolean(selectedCondition.pattern)
                            : true;

                    const hasMax = 'max' in (selectedCondition ?? {});

                    const selectedMin =
                        selectedValidationType?.value === 'length' &&
                        selectedCondition &&
                        'min' in selectedCondition &&
                        !hasMax
                            ? Boolean(selectedCondition.min)
                            : true;

                    return (
                        <div
                            className={`settings__question_category ${
                                findItem()?.id &&
                                isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                setting?.switchValue &&
                                (!selectedValidationType ||
                                    !selectedCondition ||
                                    !selectedNumber ||
                                    !selectedPattern ||
                                    !selectedMin)
                                    ? 'error'
                                    : ''
                            }`}
                        >
                            <div className="settings__response-validation-title">
                                Response Validation
                                <Switch
                                    checked={setting?.switchValue}
                                    size="small"
                                    className="custom-switch"
                                    onChange={() =>
                                        updateSettingField('switchValue', !setting?.switchValue, setting?.type)
                                    }
                                />
                            </div>

                            {setting?.switchValue && (
                                <div className={`settings__related-components`}>
                                    <Form>
                                        <Form.Item className="input-wrapper-multiselect">
                                            <FloatSelect
                                                type="common"
                                                required={false}
                                                floatLabel={'Validation type'}
                                                options={setting?.options?.map((option: any) => ({
                                                    value: option?.value,
                                                    name: option?.label
                                                }))}
                                                onChange={(value: any) => {
                                                    if (value) {
                                                        updateOptionSelectedInSetting(setting?.type, value?.value);
                                                    } else {
                                                        deselectAllOptions(setting?.type);
                                                    }
                                                }}
                                                hasError={() => false}
                                                value={
                                                    selectedValidationType
                                                        ? {
                                                              value: selectedValidationType?.label,
                                                              name: selectedValidationType?.label
                                                          }
                                                        : null
                                                }
                                                setSearch={() => {}}
                                                search={''}
                                                form={undefined}
                                                err={
                                                    !!findItem()?.id &&
                                                    isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                                    !selectedValidationType
                                                }
                                            />
                                        </Form.Item>
                                        {findItem()?.id &&
                                            isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                            !selectedValidationType && (
                                                <div
                                                    className="error-text"
                                                    style={{
                                                        margin: '-10px 0 0 0'
                                                    }}
                                                >
                                                    This field is required
                                                </div>
                                            )}
                                        {setting?.options?.some((option: any) => option.selected) && (
                                            <>
                                                <Form.Item className="input-wrapper-multiselect">
                                                    <FloatSelect
                                                        type="common"
                                                        required={false}
                                                        floatLabel={'Condition'}
                                                        err={
                                                            !!findItem()?.id &&
                                                            isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                                            !selectedCondition
                                                        }
                                                        options={setting?.options
                                                            ?.find((option: any) => option.selected)
                                                            ?.options?.map((option: any) => ({
                                                                value: option?.label,
                                                                name: option?.label
                                                            }))}
                                                        onChange={(value: any) => {
                                                            if (value) {
                                                                updateNestedOptionSelected(setting?.type, value?.value);
                                                            } else {
                                                                deselectAllNestedOptions(setting?.type);
                                                            }
                                                        }}
                                                        hasError={() => false}
                                                        value={(() => {
                                                            return selectedCondition
                                                                ? {
                                                                      value: selectedCondition.label,
                                                                      name: selectedCondition.label
                                                                  }
                                                                : undefined;
                                                        })()}
                                                        setSearch={() => {}}
                                                        search={''}
                                                        form={undefined}
                                                    />
                                                </Form.Item>
                                                {findItem()?.id &&
                                                    isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                                    !selectedCondition && (
                                                        <div
                                                            className="error-text"
                                                            style={{
                                                                margin: '-10px 0 0 0'
                                                            }}
                                                        >
                                                            This field is required
                                                        </div>
                                                    )}
                                            </>
                                        )}
                                    </Form>
                                    {(() => {
                                        return (
                                            <>
                                                {selectedCondition && 'pattern' in selectedCondition && (
                                                    <>
                                                        <Form.Item noStyle>
                                                            <FloatInput
                                                                floatLabel="Pattern"
                                                                className="input"
                                                                value={selectedCondition?.pattern || undefined}
                                                                maxLength={128}
                                                                onChange={(e) =>
                                                                    updateNestedOptionField(
                                                                        selectedCondition.label,
                                                                        'pattern',
                                                                        e?.target?.value,
                                                                        setting?.type
                                                                    )
                                                                }
                                                                placeholder="Text"
                                                                form={undefined}
                                                                error={
                                                                    !!findItem()?.id &&
                                                                    isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                                                    !selectedPattern
                                                                }
                                                            />
                                                        </Form.Item>
                                                        {findItem()?.id &&
                                                            isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                                            !selectedPattern && (
                                                                <div
                                                                    className="error-text"
                                                                    style={{
                                                                        margin: '7px 0 0 0'
                                                                    }}
                                                                >
                                                                    This field is required
                                                                </div>
                                                            )}
                                                    </>
                                                )}

                                                {selectedCondition &&
                                                    'min' in selectedCondition &&
                                                    !('max' in selectedCondition) && (
                                                        <>
                                                            <Form.Item noStyle>
                                                                <FloatInput
                                                                    floatLabel="Number"
                                                                    className="input small-input"
                                                                    type="number"
                                                                    value={selectedCondition?.min || undefined}
                                                                    onChange={(e) =>
                                                                        updateNestedOptionField(
                                                                            selectedCondition.label,
                                                                            'min',
                                                                            e?.target?.value,
                                                                            setting?.type
                                                                        )
                                                                    }
                                                                    maxLength={3}
                                                                    error={
                                                                        !!findItem()?.id &&
                                                                        isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                                                        !selectedMin
                                                                    }
                                                                />
                                                            </Form.Item>
                                                            {findItem()?.id &&
                                                                isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                                                !selectedMin && (
                                                                    <div
                                                                        className="error-text"
                                                                        style={{
                                                                            margin: '7px 0 0 0'
                                                                        }}
                                                                    >
                                                                        This field is required
                                                                    </div>
                                                                )}
                                                        </>
                                                    )}
                                                {selectedCondition &&
                                                    'max' in selectedCondition &&
                                                    !('min' in selectedCondition) && (
                                                        <>
                                                            <Form.Item noStyle>
                                                                <FloatInput
                                                                    floatLabel="Number"
                                                                    className="input small-input"
                                                                    type="number"
                                                                    value={selectedCondition?.max || undefined}
                                                                    onChange={(e) =>
                                                                        updateNestedOptionField(
                                                                            selectedCondition.label,
                                                                            'max',
                                                                            e?.target?.value,
                                                                            setting?.type
                                                                        )
                                                                    }
                                                                    maxLength={3}
                                                                    error={
                                                                        !!findItem()?.id &&
                                                                        isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                                                        !selectedMin
                                                                    }
                                                                />
                                                            </Form.Item>
                                                            {findItem()?.id &&
                                                                isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                                                !selectedMin && (
                                                                    <div
                                                                        className="error-text"
                                                                        style={{
                                                                            margin: '7px 0 0 0'
                                                                        }}
                                                                    >
                                                                        This field is required
                                                                    </div>
                                                                )}
                                                        </>
                                                    )}

                                                {selectedCondition && 'value' in selectedCondition && (
                                                    <>
                                                        <Form.Item noStyle>
                                                            <FloatInput
                                                                floatLabel="Number"
                                                                className="input small-input"
                                                                type="number"
                                                                value={selectedCondition?.value || undefined}
                                                                onChange={(e) =>
                                                                    updateNestedOptionField(
                                                                        selectedCondition.label,
                                                                        'value',
                                                                        e?.target?.value,
                                                                        setting?.type
                                                                    )
                                                                }
                                                                maxLength={3}
                                                                error={
                                                                    !!findItem()?.id &&
                                                                    isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                                                    !selectedNumber
                                                                }
                                                            />
                                                        </Form.Item>
                                                        {findItem()?.id &&
                                                            isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                                            !selectedNumber && (
                                                                <div
                                                                    className="error-text"
                                                                    style={{
                                                                        margin: '7px 0 0 0'
                                                                    }}
                                                                >
                                                                    This field is required
                                                                </div>
                                                            )}
                                                    </>
                                                )}

                                                {selectedCondition &&
                                                    'min' in selectedCondition &&
                                                    'max' in selectedCondition && (
                                                        <div className="settings__range-inputs">
                                                            <Form.Item noStyle>
                                                                <FloatInput
                                                                    floatLabel="From"
                                                                    className="input small-input"
                                                                    type="number"
                                                                    value={
                                                                        (selectedCondition as any).min
                                                                            ? (selectedCondition as any).min
                                                                            : undefined
                                                                    }
                                                                    onChange={(e) =>
                                                                        updateNestedOptionField(
                                                                            selectedCondition.label,
                                                                            'min',
                                                                            e.target.value,
                                                                            setting?.type
                                                                        )
                                                                    }
                                                                    maxLength={3}
                                                                />
                                                            </Form.Item>
                                                            <span>And</span>
                                                            <Form.Item noStyle>
                                                                <FloatInput
                                                                    floatLabel="To"
                                                                    className="input small-input"
                                                                    type="number"
                                                                    value={
                                                                        (selectedCondition as any).max
                                                                            ? (selectedCondition as any).max
                                                                            : undefined
                                                                    }
                                                                    onChange={(e) =>
                                                                        updateNestedOptionField(
                                                                            selectedCondition.label,
                                                                            'max',
                                                                            e.target.value,
                                                                            setting?.type
                                                                        )
                                                                    }
                                                                    maxLength={3}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}
                                                <div className="settings__custom-error">
                                                    {selectedCondition && (
                                                        <Form.Item noStyle>
                                                            <FloatInput
                                                                floatLabel="Custom error"
                                                                className="input"
                                                                value={(selectedCondition as any).message || ''}
                                                                maxLength={128}
                                                                onChange={(e) =>
                                                                    updateNestedOptionField(
                                                                        selectedCondition.label,
                                                                        'message',
                                                                        e.target.value,
                                                                        setting?.type
                                                                    )
                                                                }
                                                                form={undefined}
                                                            />
                                                        </Form.Item>
                                                    )}
                                                </div>
                                            </>
                                        );
                                    })()}
                                </div>
                            )}
                        </div>
                    );
                }
                if (setting?.type === 'gate_1_filtering') {
                    return (
                        <>
                            <div
                                className={`settings__question_category ${
                                    findItem()?.id &&
                                    isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                    setting?.switchValue &&
                                    !setting?.options.some((elem: any) => elem.selected)
                                        ? 'error'
                                        : ''
                                }`}
                            >
                                <div className="settings__response-validation-title">
                                    Gate 1 Filtering
                                    <Switch
                                        checked={setting?.switchValue}
                                        size="small"
                                        className="custom-switch"
                                        onChange={() =>
                                            updateSettingField('switchValue', !setting?.switchValue, setting?.type)
                                        }
                                    />
                                </div>
                                {setting?.switchValue && (
                                    <div>
                                        {setting?.options?.map((elem: any, index: any) => {
                                            return (
                                                <div className="settings__question_category-option">
                                                    <div
                                                        className={`settings__question_category-option-radio ${
                                                            elem.selected ? 'selected' : ''
                                                        }`}
                                                        onClick={() =>
                                                            updateRadioOptionSelectedInSetting(setting?.type, index)
                                                        }
                                                    ></div>
                                                    {elem.label}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                            {findItem()?.id &&
                                isFieldIdInErrors(findItem()!.id, fieldsError) &&
                                setting?.switchValue &&
                                !setting?.options.some((elem: any) => elem.selected) && (
                                    <div className="error-text" style={{ margin: '-10px 0 0 0' }}>
                                        This field is required
                                    </div>
                                )}
                        </>
                    );
                }
            })}
        </div>
    );
};
